(ns ui.components.search-selector.components.recent
  (:require
   [ui.util :as uu]
   [ui.components.button.view :as button]))

(defn search
  [{:keys [id dom-id tab-index query display-name
           active?
           on-select on-remove]}]
  [:div
   {:id dom-id
    :class (uu/cm
            "m-0 p-1.5 flex gap-2 items-center max-w-[640px] relative"
            "hover:text-base-light-text-accent text-sm rounded"
            "cursor-pointer"
            (when active?
              "bg-base-regular"))
    :tab-index tab-index
    :on-key-down (fn [e] (when (= "Enter" (.-key e)) (.stopPropagation e)))
    :on-click (when (fn? on-select)
                (fn [_]
                  (on-select id)))}
   [:div
    {:class "pl-2 w-full flex flex-col items-start justify-start"}
    [:div
     {:class "text-left font-semibold"}
     query]]
   [:div
    {:class "*:p-0 *:pr-2"}
    [button/secondary-open
     {:on-click (fn [event]
                  (.stopPropagation event)
                  (on-remove id))}
     [:i.fal.fa-times]]]])

(defn selected
  [{:keys [id dom-id tab-index icon-class title display-name
           active?
           on-select on-remove]}]
  [:div
   {:id dom-id
    :class (uu/cm
            "m-0 p-1.5 flex gap-2 items-center max-w-[640px] relative"
            "hover:text-base-light-text-accent text-sm rounded"
            "cursor-pointer"
            (when active?
              "bg-base-regular"))
    :tab-index tab-index
    :on-key-down (fn [e] (when (= "Enter" (.-key e)) (.stopPropagation e)))
    :on-click (when (fn? on-select)
                (fn [_]
                  (on-select id)))}
   (when icon-class
     [:span
      {:class "min-w-6 h-6 inline-flex justify-center items-center rounded-full bg-complement-regular"}
      [:i
       {:class (uu/cm "w-4 text-base-light-text" :fal icon-class)}]])
   [:div
    {:class "w-full flex flex-col items-start justify-start"}
    [:div
     {:class "text-base-light-text-paler"}
     title]
    [:div
     {:class "text-left font-semibold"}
     display-name]]
   [:div
    {:class "*:p-0 *:pr-2"}
    [button/secondary-open
     {:on-click (fn [event]
                  (.stopPropagation event)
                  (on-remove id))}
     [:i.fal.fa-times]]]])
